module.exports = __webpack_public_path__ + "static/media/status-q.71970ad8.png";